<template>
    <div>
        <iframe height="100%" width="100%" frameborder="0" :src="src"/>
    </div>
</template>

<script>
import {post} from "../../server/request";

export default {
    name: "innerIframeItem",
    props: {
        value: {
            type: String,
            required: true
        },
        paramMap: {
            type: Object,
            required: true
        },
        context: {
            type: Object,
            default: function () {
                return {}
            }
        },
        config: {
            type: Object,
            required: true,
            default: function () {
                return {url: '', dynamic: false}
            },
        }
    },
    data() {
        return {
            filterMap: {},
            src: ""
        }
    },
    created() {
        this.filterMap = {...this.paramMap}
        this.filterMap["entityId"] = this.value
        this.src = this.config.url;
        if (this.config.dynamic) {
            if (!this.config.url) {
                throw "请求路径不能为空";
            }
            post(this.config.url, this.filterMap).then(res => {
                if (res.data.code === '1') {
                    this.src = res.data.data || "";
                } else {
                    this.$message.error(res.data.msg)
                    this.src = "";
                }
            })
        }
    },
    methods: {}
}
</script>

<style scoped>
</style>